import React, { useState, useEffect } from 'react';
import {
  Box,
  Flex,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
  MenuItem,
  MenuList,
  Portal,
  MenuButton,
  Menu,
} from '@chakra-ui/react';
import Flag from 'react-world-flags';
import { AsYouType } from 'libphonenumber-js';
import { getCountryTelCode } from '../utils/countries';
import { RiEarthFill } from 'react-icons/ri';

interface PhoneNumberInputProps {
  country: string;
  inputProps: InputProps;
  onChange: Function;
  options: any[];
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  country,
  inputProps,
  onChange,
  options,
  ...rest
}) => {
  let [number, setNumber] = useState(inputProps.value || '');
  let [selectedCountry, setSelectedCountry] = useState(country || '');
  let [countryCode, setCountryCode] = useState(
    getCountryTelCode(country) || ''
  );

  useEffect(() => {
    setSelectedCountry(country);
    setCountryCode(getCountryTelCode(country));
  }, [country]);

  const onCountrySelected = (value: string) => {
    let code = getCountryTelCode(value);
    let parsedNumber = new AsYouType().input(`${code}${number}`);
    setCountryCode(code);
    setSelectedCountry(value);
    onChange(parsedNumber);
  };

  const onPhoneNumberChange = e => {
    let value = e.target.value;
    let parsedNumber = new AsYouType().input(`${countryCode}${value}`);

    setNumber(value);
    onChange(parsedNumber);
  };
  return (
    <InputGroup size={inputProps.size} {...rest}>
      <InputLeftElement width="4rem" mr={3} h="100%" pointerEvents="auto">
        <Menu isLazy placement="bottom-start">
          <MenuButton as={Box} w="100%" h="100%" cursor="pointer">
            <Flex
              w="100%"
              h="100%"
              pl={0.5}
              alignItems="center"
              justifyContent="center">
              {selectedCountry ? (
                <Box flex={1}>
                  <Flag height="1rem" code={selectedCountry || ''} />
                </Box>
              ) : (
                <Icon as={RiEarthFill} />
              )}
            </Flex>
          </MenuButton>
          <Portal>
            <MenuList maxH="300px" overflowY="auto" zIndex={9999}>
              {options.map((option, index: number) => (
                <MenuItem
                  key={'option-' + index}
                  onClick={() => onCountrySelected(option.value)}>
                  {option.label}
                </MenuItem>
              ))}
            </MenuList>
          </Portal>
        </Menu>
      </InputLeftElement>
      <Input
        pl="5rem"
        type="tel"
        value={number}
        pattern="[0-9]"
        onChange={onPhoneNumberChange}
        {...inputProps}
      />
    </InputGroup>
  );
};

export default PhoneNumberInput;
